import React from 'react';
import i18n, { formatNumber } from '@/utils/i18n';
import { Table } from 'reactstrap';
import { ContainerType } from '../OrderFulfillmentAddContainerTypes';
import ContainerTypeDisplay from '../../../../../components/ContainerType/ContainerTypeDisplay';

type ContainerTypeAmountsUpdatesProps = {
  oldAmounts: any[];
  newAmounts: any[];
  isDeliveryOFType: boolean;
  containerTypes: ContainerType[];
};

const ContainerTypeAmountsUpdates = ({
  oldAmounts,
  newAmounts,
  isDeliveryOFType,
  containerTypes,
}: ContainerTypeAmountsUpdatesProps) => {
  const containerTypeIds = oldAmounts
    .map((a) => a.ContainerTypeId)
    .concat(newAmounts.map((a) => a.ContainerTypeId))
    .filter((value, index, self) => self.indexOf(value) === index);

  const amounts = containerTypeIds.map((id) => {
    const oldAmount = oldAmounts.find((a) => a.ContainerTypeId === id);
    const newAmount = newAmounts.find((a) => a.ContainerTypeId === id);

    if (isDeliveryOFType) {
      return {
        ContainerTypeId: id,
        Update: `${i18n.t('Common:clean')}: ${formatNumber(
          oldAmount?.Amount || 0,
        )} -> ${formatNumber(newAmount?.Amount || 0)}`,
      };
    }

    return {
      ContainerTypeId: id,
      Update: `${i18n.t('Common:dirty')}: ${formatNumber(
        oldAmount?.Amount || 0,
      )} -> ${formatNumber(newAmount?.Amount || 0)}`,
      UpdateSealed: `${i18n.t('Common:clean')}: ${formatNumber(
        oldAmount?.AmountSealed || 0,
      )} -> ${formatNumber(newAmount?.AmountSealed || 0)}`,
    };
  });

  return (
    <Table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>{i18n.t('Common:type')}</th>
          <th>{i18n.t('Common:amount')}</th>
        </tr>
      </thead>
      <tbody>
        {amounts.map((amount, index) => (
          <tr key={index}>
            <td style={{ width: '50%' }}>
              <ContainerTypeDisplay
                containerType={containerTypes.find(
                  (ct) => ct.id === amount.ContainerTypeId,
                )}
                showContainerId={false}
                showName
                size="s"
              />
            </td>
            <td>
              <div className="d-flex flex-column">
                <span>{amount.Update}</span>
                {!isDeliveryOFType && <span>{amount.UpdateSealed}</span>}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ContainerTypeAmountsUpdates;
